import React from 'react';
import PropTypes from 'prop-types';

var SvgContextMixin = require('./svgContextMixin');
var propTypes = require('../../utils/propTypes');

var SvgChartTimeAxis = React.createClass({

  mixins: [SvgContextMixin],

  propTypes: {
    dateFrom: propTypes.isMoment.isRequired,
    dateTo: propTypes.isMoment.isRequired,
    gridColor: PropTypes.string,
    labelHeight: PropTypes.number,
    displayLabel: PropTypes.string
  },

  statics: {
    id: "TimeXAxis",
    maxGridCount: 12,
    minGridCount: 2,
    GRID_TYPE_HOUR: "Hour",
    GRID_TYPE_DAY_OF_MONTH: "DayOfMonth",
    GRID_TYPE_MONTH_OF_YEAR: "MonthOfYear",
    getGridType(dateFrom, dateTo){
      var diff = dateTo.diff(dateFrom, 'days');
      if (diff <= 12) {
        return SvgChartTimeAxis.GRID_TYPE_HOUR;
      } else if (diff <= 60) {
        return SvgChartTimeAxis.GRID_TYPE_DAY_OF_MONTH;
      } else {
        return SvgChartTimeAxis.GRID_TYPE_MONTH_OF_YEAR
      }
    },

    getGridUnit(dateFrom, dateTo){
      return SvgChartTimeAxis.getGridType(dateFrom, dateTo) == SvgChartTimeAxis.GRID_TYPE_MONTH_OF_YEAR
        ? "month"
        : "days";
    },

    getAxisUnit(dateFrom, dateTo){
      return SvgChartTimeAxis.getGridType(dateFrom, dateTo) == SvgChartTimeAxis.GRID_TYPE_HOUR
        ? 'minutes'
        : 'days';
    },

    getAxisLength(dateFrom, dateTo){
      var axisUnit = SvgChartTimeAxis.getAxisUnit(dateFrom, dateTo),
        diff = dateTo.diff(dateFrom, axisUnit);

      if (diff > 0) {
        return axisUnit == 'minutes' ? (diff + 24 * 60) : diff;
      }

      if (diff == 0 && axisUnit == 'minutes') {
        return 24 * 60;
      }

      return 1;
    },

    getStartGridDate(dateFrom, dateTo){
      var gridType = SvgChartTimeAxis.getGridType(dateFrom, dateTo);

      if (gridType === SvgChartTimeAxis.GRID_TYPE_MONTH_OF_YEAR) {
        var month = dateFrom.date() == 1
          ? dateFrom.month()
          : dateFrom.month() + 1;
        return moment()
          .year(dateFrom.year())
          .date(1)
          .month(month);
      } else {
        return moment(dateFrom);
      }
    },

    getGridCount(dateFrom, dateTo){
      var gridType = SvgChartTimeAxis.getGridType(dateFrom, dateTo),
        gridStartDate = SvgChartTimeAxis.getStartGridDate(dateFrom, dateTo),
        gridLength = gridType == SvgChartTimeAxis.GRID_TYPE_MONTH_OF_YEAR
          ? dateTo.diff(gridStartDate, 'month')
          : dateTo.diff(gridStartDate, 'days');
      
      var cellLen = Math.ceil(gridLength / this.maxGridCount),
        gridCount = Math.ceil(gridLength / cellLen);

      if (!isFinite(gridCount)) {
        return 1;
      }

      gridCount = gridCount >= this.minGridCount
        ? gridCount
        : this.minGridCount;

      if (gridType == SvgChartTimeAxis.GRID_TYPE_HOUR) {
        if (gridLength < 2) {
          return gridLength + 1;
        }
        return gridCount + 1;
      } else if (gridType == SvgChartTimeAxis.GRID_TYPE_DAY_OF_MONTH) {
        return gridCount;
      } else {
        return dateTo.date() === 1 ? gridCount + 2 : gridCount + 1;
      }
    }

  },

  getDefaultProps(){
    return {
      gridColor: "#EAEAEA"
    }
  },


  shouldComponentUpdate(nextProps){
    return nextProps.dateFrom.diff(this.props.dateFrom, 'hours')
      || nextProps.dateTo.diff(this.props.dateTo, 'hours')
      || nextProps.box[2] != this.props.box[2];
  },

  render(){
    return (
      <g id={SvgChartTimeAxis.id}>
        {this._getGrid()}
        {this._getLabel()}
      </g>
    );
  },

  _getLabel(){
    var {displayLabel, box, labelHeight} = this.props;
    if (!displayLabel) return null;

    var fontSize = this._getFontSize(),
      x = this.context.relativeX(box[0] + box[2] / 2),
      y = this.context.relativeY(box[1]) + this.context.relativeY(box[3]) - this.context.relativeY(labelHeight * (1/6));


    return <text x={x} y={y}
                 fontFamily={this.context.font}
                 fontSize={fontSize}
                 dominantBaseline="central"
                 textAnchor="middle"
    >
      {displayLabel}
    </text>
  },


  _getGrid(){
    var {dateFrom, dateTo, box, gridColor, labelHeight} = this.props;

    var gridType = SvgChartTimeAxis.getGridType(dateFrom, dateTo),
      gridUnit = SvgChartTimeAxis.getGridUnit(dateFrom, dateTo),
      gridLabel = SvgChartTimeAxis.getStartGridDate(dateFrom, dateTo),
      gridCount = SvgChartTimeAxis.getGridCount(dateFrom, dateTo),
      lastLabelDate = dateFrom.clone(),
      unitLength,
      iterateRange = Math.ceil(dateTo.diff(gridLabel, gridUnit) / gridCount);
    
    iterateRange = iterateRange || 1;
    unitLength = gridType === SvgChartTimeAxis.GRID_TYPE_HOUR
      ? box[2] / (gridCount)
      : box[2] / dateTo.diff(dateFrom, 'days');

    var grid = [];

    var x = this.context.relativeX(box[0]),
      y1 = this.context.relativeY(box[1]),
      y2 = y1 + this.context.relativeY(box[3]) - this.context.relativeY(labelHeight),
      fontSize = this._getFontSize();

    for (var i = 0; i < gridCount; i++) {
      var cellLen = gridLabel.diff(lastLabelDate, 'days') * unitLength;
      x += this.context.relativeX(cellLen);
      grid.push(
        <line
          key={"grid-line-" + i}
          x1={x}
          y1={y1}
          x2={x}
          y2={y2}
          stroke={gridColor} strokeWidth={0.4} opacity={0.75}
        />,
        <text
          key={"grid-label" + i}
          x={x}
          y={y2 + this.context.relativeY(labelHeight * (1/6))}
          textAnchor="middle"
          dominantBaseline="central"
          fontFamily={this.context.font}
          fontSize={fontSize}
        >
          {this.getLabel(gridLabel, gridType)}
        </text>,

        <text
          key={"grid-year-label" + i}
          x={x}
          y={y2 + this.context.relativeY(labelHeight * (1/3))}
          textAnchor="middle"
          dominantBaseline="text-before-edge"
          fontFamily={this.context.font}
          fontSize={fontSize}
        >
          {this.getYear(gridLabel, gridType)}
        </text>
      );

      lastLabelDate = gridLabel.clone();
      gridLabel.add(iterateRange, gridUnit);
    }

    return grid;
  },

  _getFontSize(){
    var {labelHeight} = this.props;
    return this.context.getFontSize(this.context.relativeY(labelHeight) / 3 * 0.8);
  },

  getLabel(date, type){
    return type === SvgChartTimeAxis.GRID_TYPE_MONTH_OF_YEAR
      ? this.formatMonthForLabel(date)
      : this.formatDayAndMonthForLabel(date);
  },

  getYear(date, type){
    return date.format('YYYY');
  },
  
  formatMonthForLabel(date) {
    return date.isArabic() ? date.format('MM') : date.format('MMM.');
  },
  
  formatDayAndMonthForLabel(date) {
    return date.isArabic() ? date.format('DD/MM/') : date.format('DD MMM.');
  }

});


module.exports = SvgChartTimeAxis;
